import React from 'react'

export default ({ url, children, ...props }) =>
  url ? (
    <a href={url} {...props}>
      {children}
    </a>
  ) : (
    <div {...props}>{children}</div>
  )